export default {
  article_not_available: "Not available",
  basket: {
    title: "Basket",
    articleTitle: "Articles",
    article_summary: "Article summary",
    booth_label: 'Stand label',
    booth_package: 'Stand construction package',
    booth_type: 'Stand type',
    disposal_costs: 'Disposal costs',
    late_delivery: 'Late delivery charge',
    media_package: 'Communication package',
    item: 'Item',
    netPrice: 'Net. price',
    vatPrice: 'Vat.',
    price: 'Price',
    price_in: 'Price in EUR',
    rent: 'Fee',
    size: 'Stand area',
    total: "Total net",
    total_gross: "Total gross (VAT incl. [vatRate]%)",
    total_gross_summary: "Total gross (VAT incl.)",
    carpetColor: "Carpet Color",
    squareMeter: "sqm"
  },
  booth_articles: {
    per_unit: "each"
  },
  boothTypes: {
    corner_left: 'Corner stand (left)',
    corner_right: 'Corner stand (right)',
    head: 'Peninsula stand',
    island: 'Island stand',
    row: 'Linear stand',
    corner: 'Corner stand',
    unknown: 'Unknown'
  },
  buttons: {
    next: 'Next',
    next_to: '>',
    nextWithoutBooth: "Next without stand package",
    prev: 'Back',
    prev_to: '<',
    select: 'Select',
    submit: 'Submit',
    show: 'Show',
    remove: 'Remove',
    order_new_booth: 'Order new stand',
    order_new_articles: 'Order additional articles',
    remove_booth: 'Remove stand construction package from basket'
  },
  categories: {
    all: "All"
  },
  checklist: {
    size_set: "Width and depth set",
    booth_typ_set: "Type of stand selected",
    booth_package_set: "Stand package selected",
    address_set: "Address set",
    payment_address_set: "Payment address set",
    data_set: "Name, company and email address set",
    company_set: "Hall and stand number set",
    hall_name_set: "Hall name set",
    booth_number_set: "Stand number set",
    vat_set: "The VAT ID is correct",
    vat_not_set: "The VAT ID is correct",
    passwords: "Passwords need to match (Min 8 characters)",
    booth_label: 'Stand label required',
    order_number: 'PO/Order number required',
    minimum_checkout: 'Select at least a stand package or one additional package'
  },
  contact: {
    title: 'Contact'
  },
  descriptions: {
    select_new_booth_or_articles: 'Please select if you want to order a new stand or if you want to order additional articles.',
    select_booth: 'Please select a stand, for which you want to order additional articles:'
  },
  errors: {
    occurred: "Error occurred!",
    please_try_again: "Please try again. If the error occurrs several times, please contact the support.",
    invalid_credentials: "These credentials do not match our records.",
    registration_failed: "Registration could not be completed. Please check your information",
    email_taken: "Registration failed. The email address has already been taken.",
    closed: 'Shop is closed for this exhibition. We can not can not accept any orders anymore',
    data_invalid: "The given data is invalid. Please check:",
    email_required: "Email is missing.",
    name_required: "Name of contact person is missing.",
    name_min: "Name of contact person needs to be at least 2 characters.",
    name_max: "Name of contact person maximal length is 191 characters.",
    street_name_required: "Street name is missing.",
    street_name_max: "Street name maximal length is 191 characters.",
    place_required: "Place name is missing.",
    place_max: "Place name maximal length is 191 characters.",
    zip_required: "Zip code is missing.",
    zip_max: "Zip code maximal length is 10 characters.",
    street_number_max: "Street number maximal length is 10 characters.",
    phone_max: "Phone number maximal length is 191 characters.",
    company_max: "Company name maximal length is 191 characters.",
    vat_id: "The Vat ID is not correct",
    basket_depth_numeric: "Die Tiefenangabe des Stands ist nicht numerisch.",
    basket_width_numeric: "Die Breitenangebe des Stands ist nicht numerisch.",
    bill_name_min: "Billing name of contact person needs to be at least 2 characters.",
    bill_name_max: "Billing name of contact person maximal length is 191 characters.",
    bill_street_name_max: "Billing street name maximal length is 191 characters.",
    bill_place_max: "Billing place name maximal length is 191 characters.",
    bill_zip_max: "Billing zip code maximal length is 10 characters.",
    bill_street_number_max: "Billing street number maximal length is 10 characters.",
    confirmed_business_customer: "Confirmation that you are a business customer is required.",
    order_number: "PO/Order number required.",
    use_order_number: "Please select <b>Yes</b> or <b>No</b>.",
    session_timeout: "Session timeout. Please reload the page.",
    exhibition_hall_regex: "Please use only Latin characters, numbers, whitespace and the following special characters: +_-.,/&#",
    exhibition_booth_number_regex: "Please use only Latin characters, numbers, whitespace and the following special characters: +_-.,/&#",
  },
  forms: {
    placeholders: {
      name: "Name of contact person",
      bill_name : "Name of contact person (bill)",
      email: "Email address",
      company: "Name of your company",
      company_and_legal_form: "Name of your company and legal form",
      legal_form: "Legal form",
      country: "Name of your country",
      vat_id: "Vat ID from your company",
      street_name: 'Street name',
      street_number: 'No.',
      zip: 'e.g. 12345',
      place: 'Name of the place',
      phone: 'e.g. 0123 456 7890',
      hall: "Name of exhibition hall, e.g. Hall B",
      booth_number: "Number of your stand, e.g. B7",
      comment: "Questions, comments ...",
      password: "Password, min. 8 characters",
      passwordConfirmation: "Password confirmation",
      check: "Checking..."
    },
    name: "Name",
    bill_name : "Name (bill)",
    email: "Email",
    company: "Name of your company",
    company_and_legal_form: "Name of your company and legal form",
    legal_form: "Legal form",
    country: "Country",
    vat_id: "Vat ID",
    street_name: 'Street name / No.',
    zip_place: 'Zip code / place',
    bill_zip_place: 'Zip code / place',
    phone: 'Phone number',
    hall: "Exhibition hall",
    booth_number: "Stand number",
    comment: "Comment",
    password: "Password",
    passwordConfirmation: "Confirmation",
    order_number: "PO/order number",
    use_order_number: "PO/Order number in use",
    order_number_notice: "Note: Please note that the subsequent consideration of PO/order number will result in a new invoice and will be charged with an expense fee of 25€!",
    bill_address_notice: "Note: Please note that after invoicing, if the invoice recipient is subsequently changed, a 25€ expense fee will be charged!"
  },
  labels: {
    site_notice: 'Site notice',
    privacy: 'Data protection notice',
    general_terms: 'General terms',
    description: 'Description',
    select_booth_type: 'Please select your stand type',
    select_booth_package: 'Select your stand construction package',
    set_size: 'Please enter your stand dimensions',
    depth: 'Depth',
    width: 'Front',
    sqm: 'sqm',
    carpet_color_selection: 'Carpet color selection',
    booth_package: 'Stand package: {0}',
    booth_label: 'Stand label',
    booth_label_characters_inclusive: '{0} characters inclusive',
    alternative_packages: 'Alternatives',
    category: 'Category',
    exhibition_hall: 'Exhibition hall',
    exhibition_booth_number: 'Stand number',
    email: 'Email address',
    phone: 'Phone',
    payment_address: 'Payment address',
    address: 'Address',
    notice: 'Notice',
    per_unit: 'each',
    search: 'Search',
    select_place: 'Select place',
    select_exhibition: 'Select exhibition',
    no_results: 'No results found',
    no_entries: 'No upcoming exhibitions found',
    requests_overview: 'Request overview',
    summary: 'Summary',
    order_number: 'PO/Order number',
    documents: 'Documents',
    request_in_progress: "Please be patient, while your order is being processed",
    checklist: "Checklist",
    contact_data: "Information",
    login: "Login",
    register: "Registration",
    guest: "Continue as guest",
    submit_request: "Place a binding order",
    add_bill_address: "add billing address",
    remove_bill_address: "no billing address",
    already_customer: "Do you already have an account?",
    no_account: "No account?",
    general_terms_submit: "Through submitting your order, you accept our <a href='[path_to_general_terms]' target='_blank'>General Terms</a>.",
    confirmed_business_customer: "I hereby confirm that I am a business customer.",
    yes: "Yes",
    no: "No",
    different_billing_address: 'Different billing address',
    client: 'Client/Invoice recipient',
    password_reset: 'Forgot password?',
    printable: 'Printable',
    inclusive_abbreviation: 'incl.'
  },
  misc: {
    power: "including power supply (3kW)"
  },
  placeholders: {
    booth_label: 'Required field',
  },
  success: {
    title: "Thank you for your order!",
    message: "We received your order. You will receive a confirmation of your order submission shortly via email."
  },
  summary: {
    package: "System stand",
    articles: "Additional equipment",
    other_costs: "Stand space rent and obligatory services",
    other_costs_notice: "will be calculated separately by organizer once per stand"
  },
  tab: {
    key_data: "Stand Information",
    booth_selection: 'Package choice',
    booth_set_up: 'Configuration',
    articles: 'Additional items',
    summary: 'Summary',
    submit: 'Finish',
    prints: 'Prints'
  },
  table: {
    id: "# ID",
    exhibition: "Exhibition",
    booth: "Selected stand package",
    status: "Status",
    created_at: "Created at",
    updated_at: "Last update",
    options: "Options"
  },
  urls: {
    site_notice: "/site-note",
    privacy: "/privacy-policy",
    general_terms: "/terms/LUECO-General-Conditions-of-Delivery-and-Payment.pdf"
  },
  toast: {
    title: {
      success: 'Successful',
      error: 'An error occurred',
      warning: 'Warning',
      info: 'Notice'
    },
    message: {
      error: 'An error occurred. Please try again'
    },
    warnings: {
      too_large: 'The uploaded file exceeds the 500mb limit'
    }
  },
  print_cloud: {
    indicator: {
      delete_upload: 'Deleting upload',
      mark_as_user_ready: 'Marking process as "Done"',
      submit_order: 'Processing order request',
      upload: 'Uploading file',
    }
  },
  configurator: {
    alerts: {
      success: {
        files_are_being_processed: 'Your files are being processed by out team.'
      }
    },
    buttons: {
      add: 'Add',
      add_articles: 'Add article',
      add_graphic_design: 'Add graphic option',
      add_lettering: 'Add exhibitor name on fascia',
      add_more_printable_articles: 'Add more printable articles',
      add_print: 'Add print',
      cancel: 'Cancel',
      close: 'Close',
      delete: 'Remove',
      delete_graphic_file: 'Remove graphic',
      download_all_files: 'Download all files',
      edit_lettering: 'Edit lettering',
      mark_as_ready: 'Mark printprocess as "done"',
      mark_as_order: 'Order printprocess',
      no: 'No',
      ok: 'Ok',
      remove_from_basket: 'Remove from basket',
      update: 'Update',
      upload: 'Upload',
      upload_booth_draft: 'Upload artwork',
      upload_graphic_file: 'Upload graphic',
      upload_now: 'Upload now',
      yes: 'Yes'
    },
    descriptions: {
      all_required_files_uploaded: 'You have uploaded all required files. You can now mark the process as "done".',
      contact_general: 'For general questions about the store please write an email to shop[at]lueco.de.',
      contact_order: 'After receiving your order confirmation, you will have a permanent contact person who will be happy to answer all detailed questions about your order!',
      external_print_cloud_introduction: 'Welcome to the print management of Lüco. Please upload a grahic or a logo for every print. When you uploaded all files, you can mark the process as "done". After that step, we can start printing the files on your bought articles. If you find an error and already mark the process as "done", please contact us.<br><br><ul><li>A separate file must be uploaded for each individual graphic position.</li><li>Please upload your mockup!</li><li>Print dimensions can be found here in the cloud, in your booth layout, or in the technical data sheet.</li><li>You will receive the upload deadline via email.</li><li>Mark the "Print Cloud" as "done" once everything has been uploaded.</li><li>The graphic layout plan must include the hall and booth number, as well as the illustrated arrangement of the graphics.</li><li>The cloud will send automatic reminders until it is marked as "complete."</ul>',
      internal_print_cloud_introduction: 'Welcome to the print management of Lüco. Please upload a grahic or a logo for every print. When you uploaded all files, you can mark the process as "done". After that step, we can start printing the files on your bought articles. If you find an error and already mark the process as "done", please contact us.<br><br><ul><li>A separate file must be uploaded for each individual graphic position.</li><li>Please upload your mockup!</li><li>Print dimensions can be found here in the cloud, in your booth layout, or in the technical data sheet.</li><li>You will receive the upload deadline via email.</li><li>Mark the "Print Cloud" as "done" once everything has been uploaded.</li><li>The graphic layout plan must include the hall and booth number, as well as the illustrated arrangement of the graphics.</li><li>The cloud will send automatic reminders until it is marked as "complete."</ul>',
      print_cloud_introduction: 'Welcome to the print management of Lüco. Please upload a grahic or a logo for every print. When you uploaded all files, you can mark the process as "done". After that step, we can start printing the files on your bought articles. If you find an error and already mark the process as "done", please contact us.',
      stand_type_selection: 'If you are facing the back wall and the open corner is on your right side, you have a "corner stand right", if the open corner is on your left side, you have a "corner stand left".',
      upload_files_for_every_print: 'Please upload a logo or a graphic for every print you bought.Only if every print has an uploaded file, you can mark the process as "done".',
      upload_files_later: 'You can upload your print files later into the print cloud.',
    },
    form: {
      errors: {
        booth_draft: 'No artwork selected',
        graphic_design: 'No surface selected',
        lettering: 'Label missing',
        print_article: 'No print article selected',
        spanning_mode: 'No print mode selected',
      },
      labels: {
        choose_surface: 'Select surfaces',
        seamless_print: 'Seamless Print',
        seamless_print_with_note: 'Seamless Print (You need to select at least 2 surfaces)',
        choose_size: 'Select size in squaremeter',
        current_print_article: 'Current print article',
        current_surface: 'Current surface',
        drag_and_drop_file: 'Drag and Drop file',
        hint_lettering: 'Lettering',
        hint_print: 'Print',
        how_to_order_graphics: 'How do I order graphics?',
        lettering: 'Lettering*',
        lettering_across_all_surfaces: 'Lettering across all surfaces',
        lettering_per_surface: 'Lettering per surface',
        notes: 'Notes',
        no_options: 'The selected surfaces do not have the same print articles',
        no_options_last_minute: 'Print available on demand',
        or: 'OR',
        per_surface: 'per surface',
        please_select: 'Please select',
        print_across_all_surfaces: 'Print across all surfaces',
        print_article: 'Print article',
        print_article_late: 'Print article on demand',
        print_per_surface: 'Print per surface',
        select_file: 'Select file',
        select_print_article: 'Select print article',
        selected_file: 'Selected file',
        spanning_mode: 'Select surface print assignment',
        spanning_mode_hint: '(*Wallpanels can´t be seamlessly printed)',
        single_surface: 'Surface',
        surface: 'Surface',
        surface_selected: 'surface selected',
        surfaces_selected: 'surfaces selected',
      },
      placeholders: {
        please_select: 'Please select',
        please_select_surface_first: 'Please select a surface first'
      },
    },
    headings: {
      basket_reorder: 'Basket',
      booth_package: 'Stand package',
      booth_draft_optional: 'Mockup exhibitor',
      booth_draft_required: 'required',
      graphic_design: 'Additional Graphic Options',
      graphic_design_deadline: 'You will receive the deadline for uploading the print data in your order confirmation',
      information: 'Information',
      lettering: 'Lettering/Graphics',
      lettering_required: 'Lettering/Graphics (required)',
      printable_article: 'Printable article',
      print_configuration: 'Print configuration',
      print_cloud: 'Lüco print management',
      summary: 'Summary',
      print_job_requests: 'Print request versions'
    },
    indicators: {
      check_availability: 'Checking availabilities',
      delete_upload: 'Deleting upload',
      mark_as_user_ready: 'Marking process as "done"',
      one_moment_please: 'One moment please',
      remove_booth_draft: 'Deleting artwork',
      submit_order: 'Processing order request',
      update_lettering: 'Updating lettering',
      update_print_article: 'Updating print article',
      update_surface: 'Updating surface',
      upload: 'Uploading file',
    },
    labels: {
      article: 'Article',
      articles: 'Articles',
      basket: 'Basket',
      booth_package: 'Stand package',
      booth_type: 'Stand type',
      characters_inclusive: 'Characters inclusive',
      company: 'Company',
      count: 'Count',
      dimensions: 'Dimensions',
      exhibition_booth_number: 'Exhibition stand number',
      exhibition_hall: 'Exhibition hall',
      in_basket: 'In basket',
      booth_draft: 'Artwork',
      no_booth_draft_uploaded: 'No artwork uploaded',
      no_prints_selected: 'No prints selected',
      no_surfaces_selected: 'No surfaces selected',
      price_current: 'Current price',
      price_new: 'New price',
      printing_information: 'Printing information',
      upload_file_later: 'The graphic can be uploaded at a later time',
      upload_missing: 'Upload is missing',
      file_missing: 'File could not be found',
      file_missing_reupload: 'File could not be found. Please reupload the file.',
      deleted: 'Deleted',
      required_surface: 'This surface can not be changed, because it is a mandatory surface.',
      no_alternative_print_articles: 'There are no alternative print articles available for this surface.',
      no_alternative_surfaces: 'There are no alternative surfaces with the same printed article available.',
      no_documents_available: 'No documents available.',
      no_information: 'No information'
    },
    modals: {
      titles: {
        add_graphic_design: 'Add graphic option',
        add_lettering: 'Add lettering',
        add_more_printable_articles: 'Add more printable articles',
        add_print: 'Add print',
        article_description: 'Article description',
        edit_lettering: 'Edit lettering',
        edit_print_article: 'Edit print article',
        edit_surface: 'Edit surface',
        upload_booth_draft: 'Upload artwork',
        upload_graphic_file: 'Upload graphic'
      }
    },
    notices: {
      messages: {
        articles_without_print: 'You have not select a print for every printable article. Do you still want to continue? You can order the prints at a later time. More information will be available in the confirmation email after your order.',
        delete_upload: 'Do you really want to delete the uploaded file?',
        lettering: 'You have to select the required lettering first, before you can proceed with the order process.',
        lettering_selected: 'Selected',
        minimum_square_meter: 'You need at least [SQUARE_METER]  square meter to select this booth package.',
        missing_graphic_files: 'You have not uploaded a graphic for every selected print. Do you still want to continue? You can upload the graphics at a later time. More information will be available in the confirmation email after your order.',
        minimum_checkout: 'You need to select a booth package or at least one additional article before you can continue to submit your request',
        remove_booth_draft: 'Do you really want to delete the artwork?',
        remove_print_article: 'Do you really want to remove the print article from your basket?'
      },
      titles: {
        articles_without_print: 'Article without print',
        booth_package_selection: 'Booth package selection',
        delete_upload: 'Delete upload',
        lettering: 'Lettering',
        missing_graphic_files: 'Missing graphics',
        minimum_checkout: 'Empty basket',
        remove_booth_draft: 'Delete artwork',
        remove_print_article: 'Remove print article'
      },
      warnings: {
        article_removed: 'This article was removed from assortment for this exhibition. Please contact the support.',
        missing_print_article: '[ARTICLE_NAME] for "[ARTICLE_PRINT_NAME]" was removed from assortment for this exhibition.',
        no_print_articles_available: 'No new prints can be added currently. Please contact the support.',
        not_bookable_print_article: '[ARTICLE_NAME] for "[ARTICLE_PRINT_NAME]" can not be ordered.'
      }
    },
    tables: {
      columns: {
        file: 'File',
        graphic_file: 'Graphic file',
        lettering_graphic_file: 'Label/Graphic file',
        price: 'Price',
        price_per_piece: 'Price per piece',
        print_article: 'Print article',
        print_dimensions: 'Print dimensions',
        surface: 'Surface',
        count: 'Count',
        date: 'Date',
      }
    },
    toasts: {
      messages: {
        booth_draft: 'Artwork successfully uploaded',
        booth_draft_deleted: 'Artwork successfully deleted',
        lettering_updated: 'Lettering successfully updated',
        mark_as_ready: 'The process was successfully marked as "done"',
        print_article_updated: 'Print article successfully updated',
        surface_updated: 'Surface successfully updated',
        upload_deleted: 'Artwork deleted',
        upload_successful: 'Graphic successfully uploaded'
      },
      errors: {
        booth_draft: 'Artwork could not be uploaded',
        booth_draft_deleted: 'Artwork could not be deleted',
        lettering_updated: 'Lettering could not be updated',
        mark_as_ready: 'The process could not be marked as "done"',
        print_article_updated: 'Print article could not be updated',
        surface_updated: 'Surface could not be updated'
      }
    }
  }
}